/* RESPONSIBLE TEAM: team-proactive-support */
interface ScaleSettings {
  minumum: number;
  maximum: number;
  zoomFactor: number;
}

interface OptionalScaleSettings {
  minumum?: number;
  maximum?: number;
  zoomFactor?: number;
}

const DEFAULT_SCALE_SETTINGS: ScaleSettings = {
  minumum: 0.25,
  maximum: 2,
  zoomFactor: 0.1,
};

export { ScaleSettings, OptionalScaleSettings, DEFAULT_SCALE_SETTINGS };
